import Head from "next/head";

interface PreloadProps {
  images?: string[];
  other?: string[];
}

function Preload({ images, other }: PreloadProps) {
  if ((images ?? []).length === 0 && (other ?? []).length === 0) {
    return <></>;
  }
  return (
    <Head>
      {(images ?? []).map((url, i) => (
        <link
          key={i}
          rel="preload"
          href={url}
          as="image"
        />
      ))}
      {(other ?? []).map((url, i) => (
        <link
          key={i}
          rel="preload"
          href={url}
        />
      ))}
    </Head>
  );
}

export default Preload;
